module.exports = __webpack_public_path__ + "img/implement-width.dca91b50.png";